import * as XLSX from 'xlsx';
import { SavedOffer, SavedWorkOrder } from '../types';

/**
 * Export selected offers and work orders to an Excel file
 */
export function exportToExcel(
    offers: SavedOffer[],
    workOrders: SavedWorkOrder[]
): void {
    // Create workbook
    const workbook = XLSX.utils.book_new();

    // Work Orders Sheet
    if (workOrders.length > 0) {
        const workOrderData = workOrders.map(wo => ({
            'Document Number': wo.documentNumber,
            'Date': wo.formData.paivamaara,
            'Company': wo.formData.yritys,
            'Contact': wo.formData.yhteyshenkilo,
            'Email': wo.formData.sahkoposti,
            'Phone': wo.formData.puhelin,
            'Customer Number': wo.formData.asiakasnumero,
            'VAT ID': wo.formData.ytunnus,
            'Address': wo.formData.osoite,
            'Postal Code': wo.formData.postinumero,
            'City': wo.formData.paikkakunta,
            'Line of Business': wo.formData.lineOfBusiness,
            'Merkki': wo.formData.merkki,
            'Product Group': wo.formData.tuoteryhma,
            'Site': wo.formData.kohde,
            'Subtotal': wo.totals.subtotal,
        }));

        const workOrderSheet = XLSX.utils.json_to_sheet(workOrderData);
        XLSX.utils.book_append_sheet(workbook, workOrderSheet, 'Work Orders');
    }

    // Offers Sheet
    if (offers.length > 0) {
        const offerData = offers.map(offer => ({
            'Document Number': offer.documentNumber,
            'Customer Name': offer.customerName,
            'Address': offer.customerAddress,
            'Notes': offer.customerNotes,
            'Subtotal': offer.totals.subtotal,
        }));

        const offerSheet = XLSX.utils.json_to_sheet(offerData);
        XLSX.utils.book_append_sheet(workbook, offerSheet, 'Offers');
    }

    // Generate filename with date and job number if available
    const date = new Date().toISOString().split('T')[0];
    
    // Collect job numbers from work orders
    const jobNumbers = workOrders
      .map(wo => wo.formData?.jobNumber)
      .filter((jn): jn is string => !!jn && jn.trim() !== '');
    
    let filename: string;
    if (jobNumbers.length === 1) {
      // Single work order with job number
      filename = `workorder-${jobNumbers[0]}-${date}.xlsx`;
    } else if (jobNumbers.length > 1) {
      // Multiple work orders - use first job number
      filename = `workorders-${jobNumbers[0]}-${date}.xlsx`;
    } else {
      // No job numbers - use generic name
      filename = `halton_export_${date}.xlsx`;
    }

    // Trigger download
    XLSX.writeFile(workbook, filename);
}
